/** Customer-supplied "Security of workholding" chart for 6061-T6 aluminum
 *  with APGX 331R MG12 or APGX 332R MG12. Rows: DOC per side (in).
 *  Columns: workholding security rating 1–10 (10 = most secure).
 *  Cells: feed in inches per revolution; null = X (not recommended). */
export const workholdingRatings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export const workholdingRows: { doc: string; feeds: (string | null)[] }[] = [
  {
    doc: '.050',
    feeds: [null, null, null, '.030', '.036', '.041', '.047', '.053', '.060', '.066'],
  },
  {
    doc: '.100',
    feeds: [null, null, null, '.027', '.033', '.039', '.045', '.051', '.057', '.063'],
  },
  {
    doc: '.150',
    feeds: [null, null, null, '.024', '.030', '.036', '.042', '.048', '.054', '.058'],
  },
  {
    doc: '.200',
    feeds: [null, null, null, null, '.027', '.032', '.037', '.042', '.047', '.052'],
  },
  {
    doc: '.250',
    feeds: [null, null, null, null, null, '.030', '.035', '.040', '.045', '.050'],
  },
  {
    doc: '.300',
    feeds: [null, null, null, null, null, null, '.029', '.036', '.043', '.050'],
  },
  {
    doc: '.350',
    feeds: [null, null, null, null, null, null, null, '.036', '.041', '.046'],
  },
  {
    doc: '.400',
    feeds: [null, null, null, null, null, null, null, null, '.036', '.040'],
  },
]

export const workholdingExplanation =
  'This is the published workholding reference, not a method for certifying a setup. The brochure does not define how to assign a security rating. Some chart values exceed the separate 20 hp chip-control starting range; do not combine the two tables or treat the chart as permission to exceed machine or setup limits. Ask technical assistance to review your application before using these values.'
